const P = {
  APP: '/',
  AUTH: {
    INDEX: '/auth/',
    LOGIN: '/auth/login/',
    REGISTER: '/auth/register/',
    PLAN: '/auth/choose-plan/',
    RESET_PASSWORD: '/auth/reset-password/',
    UPDATE_PASSWORD: '/auth/ext/reset-password/:hash',
    ACCOUNT: '/auth/account',
    CONFIRM: '/auth/confirm',
  },
  SETUP: {
    INDEX: '/setup/',
    QUESTIONS: '/setup/questions',
    CONFIRM_EMAIL: '/setup/:hash',
    MARKETING: '/setup/marketing',
    REVENUE: '/setup/revenue',
  },
  DASHBOARD: {
    INDEX: '/dashboard',
    PERMISSION_ERROR: '/no-permission',
  },
  PROFILE: {
    INDEX: '/profile',
    INVOICES: '/profile/settings/invoices',
    SETTINGS: {
      USER: '/profile/settings/user',
      SECURITY: '/profile/settings/security',
      WORKSPACES: '/profile/settings/workspaces',
      NETWORKS: '/profile/settings/networks',
      INTEGRATIONS: '/profile/settings/integrations',
      PREFERENCES: '/profile/settings/preferences',
      WORKSPACE: {
        USERS: '/profile/settings/workspace/users',
        INTEGRATIONS: '/profile/settings/workspace/integrations',
        PREFERENCES: '/profile/settings/workspace/edit',
        BILLING: '/profile/settings/workspace/billing',
        INVOICE: '/profile/settings/workspace/invoice',
      },
    },
  },
  BILLING: {
    INDEX: '/billing/',
    CHOOSE_PLAN: '/billing/choose-plan',
    APPSUMO: '/billing/redeem-appsumo-code',
    SAASZILLA: '/billing/redeem-saaszilla-code',
  },
  AD: {
    INDEX: '/ad',
    CHOOSE_METHOD: '/ad/choose-method',
    CREATE: '/ad/create',
  },
  APPS: {
    INDEX: '/apps',
    CONNECT_APP: '/apps/:app',
  },
  AUDIENCES: {
    INDEX: '/audiences',
    CREATE: '/audiences/create',
  },
  POSTBACKS: {
    INDEX: '/postbacks',
    CONVERSION: '/postbacks/conversion',
    OUTGOING: {
      INDEX: '/postbacks/outgoing',
    },
  },
  RETENTION: {
    INDEX: '/retention',
    CRM: '/retention',
    CHARTS: '/retention/charts',
  },
  GUEST: {
    INDEX: '/guest',
    CONFIRM_INVITE: '/guest/confirm-invitation',
    CONNECT_ACCOUNTS: '/guest/connect-accounts',
    CONFIRM_CRM_INVITATION: '/guest/crm/confirm-invitation',
    BOOK_A_DEMO: '/guest/book-demo',
  },
  REPORTING: {
    INDEX: '/reporting',
    CREATIVE: '/reporting/creative',
    INNER: {
      DASHBOARD: '/reporting/:id/dashboard',
      GENDER: '/reporting/:id/gender',
      DEVICES: '/reporting/:id/devices',
      AGE: '/reporting/:id/age',
      COMBINATIONS: '/reporting/:id/combinations',
      KEYWORDS: '/reporting/:id/keywords',
      SEARCH_TERMS: '/reporting/:id/search-terms',
      LOCATIONS: '/reporting/:id/locations',
      ADS: '/reporting/:id/ads',
    },
  },
  CRM: {
    INDEX: '/crm',
    CONTACTS: '/crm/contacts',
    DEALS: '/crm/deals',
    CONVERSION: '/crm/conversion_rule',
    DATANINJA: {
      FIELDS: '/crm/dataninja/:id',
      STATUSES: '/crm/dataninja/:id/statuses',
      ACCESS: '/crm/dataninja/:id/access',
      CONFIGURATION: '/crm/dataninja/:id/configuration',
      INTEGRATION: '/crm/dataninja/:id/integration',
      SUCCESS: '/crm/dataninja/:id/success',
    },
    DATA_LIST: '/crm/form/:id/leads',
    VIEW: '/crm/form/:id/view',
  },
  BUILDER: {
    INDEX: '/website-builder',
    CREATE: '/website-builder/create',
  },
  NOTIFICATIONS: {
    INDEX: '/notifications',
  },
  SALES: {
    INDEX: '/sales',
    CRM: '/sales/crm',
    POSTBACKS: '/sales/postbacks',
    EVENTS: '/sales/events',
  },
  DOMAIN: {
    INDEX: '/domain',
    EDIT: (id) => `/domain/${id}/edit`,
    CREATE: '/domain/create',
    STATUS: '/domain/:status',
  },
  WEBSITES: {
    INDEX: '/websites',
    EDIT: (id) => `/websites/${id}/edit`,
    CREATE: '/websites/create',
    STATUS: '/websites/:status',
  },
  RULES: {
    INDEX: '/rules',
  },
  URL: {
    INDEX: '/url',
    INNER: {
      DASHBOARD: '/url/:id/dashboard',
    },
  },
  REPORT: {
    INDEX: '/report',
    USER_JOURNEY: '/report/user-journey',
  },
  ACCOUNTS: {
    INDEX: '/accounts',
  },
  PNL_REPORT: {
    INDEX: '/pnl-report',
    CUSTOM_COST: '/pnl-report/custom-cost',
  },
  ACQUISITION: {
    INDEX: '/acquisition',
    DEALS: '/acquisition/deals',
  },
  PRODUCTS: {
    INDEX: '/products',
  },
  NINJA_AI: {
    INDEX: '/ai',
  },
};

export default P;
